import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import ItemImgCard from '@components/dataDisplay/Store/ItemImgCard';
import { IinventoryItem, IstoreItem } from '@typings/store/storeItem.interface';
import { IluckydrawItem } from '@typings/store/luckydraw.interface';

const Container = styled.div`
  padding: 8px;
  width: 100%;
  background-color: var(--cardBackgroundColor);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  border: 1px solid var(--lineColor);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
`;

const EmptyCard = styled.div`
  width: 52px;
  height: 52px;
  background: var(--backgroundColor);
  border-radius: 8px;
  font-size: 11px;
  border: 1px solid var(--lineColor);
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  position: relative;
  font-weight: 300;
  color: var(--subTextColor);
`;

type Props = {
  materialItemID: string;
  photocardID;
  setDisabled?: any;
  materialCount?: number;
};
function CompareMyInventory({
  materialItemID,
  photocardID,
  setDisabled,
  materialCount,
}: Props) {
  const [isInStock, setIsInStock] = useState<boolean>(false);
  const [originDataID, setOriginDataID] = useState<string>('');
  const [userInvetoryData, setUserInventoryData] = useState<IinventoryItem>();
  const { data: myInventoryList } = useCollection<IinventoryItem>(
    `${CollectionPath.PHOTOCARD}/${photocardID}/inventory`,
    { listen: true },
  );

  const { data: originItemData } = useDocument<IstoreItem>(
    `${CollectionPath.STORE}/${originDataID}`,
    { listen: true },
  );
  const { data: materialData } = useDocument<IstoreItem>(
    `${CollectionPath.STORE}/${materialItemID}`,
  );

  useEffect(() => {
    const filterList: IinventoryItem[] = myInventoryList
      ? myInventoryList.filter((item) => item.id === materialItemID)
      : [];

    if (filterList && filterList[0]) {
      setIsInStock(true);
      setUserInventoryData(filterList[0]);
      setOriginDataID(filterList[0].originItemID || '');
    } else {
      // 재고가 없을 때 상태 초기화
      setIsInStock(false);
      setUserInventoryData(undefined);
      setOriginDataID('');
    }

    const stokeLength = filterList?.[0]?.multiple?.length ?? 0;
    const maxCount = Number(materialCount);

    setDisabled(stokeLength < maxCount);
  }, [myInventoryList, setDisabled, materialItemID, materialCount]);

  return (
    <Container>
      <span>소비 재료</span>
      <ItemImgCard
        style={{ width: 40, height: 40 }}
        data={{ ...materialData, reinforceCount: materialCount || 0 }}
      />

      <span style={{ color: 'var(--primaryColor)' }}>내 인벤토리 재고</span>
      {isInStock && originItemData ? (
        <ItemImgCard
          data={{ ...originItemData, ...userInvetoryData }}
          style={{
            width: 40,
            height: 40,
            border: '1px solid var(--primaryColor)',
          }}
        />
      ) : (
        <EmptyCard>재료 없음</EmptyCard>
      )}
    </Container>
  );
}

export default React.memo(CompareMyInventory);
